module.exports = __webpack_public_path__ + "img/btn-landscape.8fc552f5.svg";